import { render, staticRenderFns } from "./StockBatchReportTable.vue?vue&type=template&id=89d6267e&"
import script from "./StockBatchReportTable.vue?vue&type=script&lang=ts&"
export * from "./StockBatchReportTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports